import { makeEventNamespace } from '@os/dom/events'
import { openKlaviyoOnsiteForm } from '@os/klaviyo'

/**
 * `<split-callout>` — opens a Klaviyo onsite form when a CTA configured with a
 * form id is clicked.
 *
 * Hand-authored custom element module, included next to its markup with
 * `<script src="{{ 'split-callout.js' | asset_url }}" type="module">`. Shared
 * behavior comes from the `@os/*` modules resolved by the theme import map. See
 * `docs/architecture.md`.
 *
 * Markup contract:
 * - CTA elements carry `.js-split-callout-cta`.
 * - A CTA opts in with `data-klaviyo-form-id="<klaviyo form id>"`.
 */

const CTA_SELECTOR = '.js-split-callout-cta'

class SplitCallout extends HTMLElement {
  #cleanup = null

  connectedCallback() {
    if (this.#cleanup != null) {
      return
    }

    const namespace = makeEventNamespace()

    namespace.addDelegatedEventListener(
      this,
      CTA_SELECTOR,
      'click',
      (cta, evt) => {
        const formId = cta.getAttribute('data-klaviyo-form-id')?.trim()

        if (!formId) {
          return
        }

        evt.preventDefault()
        openKlaviyoOnsiteForm(formId)
      }
    )

    this.#cleanup = () => {
      namespace.destroy()
    }
  }

  disconnectedCallback() {
    this.#cleanup?.()
    this.#cleanup = null
  }
}

// Sections can be re-rendered by the theme editor; defining twice throws.
if (!customElements.get('split-callout')) {
  customElements.define('split-callout', SplitCallout)
}
